import request from '@/router/axios'

export function fetchRelateItemList(query,id) {
  return request({
    url: `/basic/admin/topic-relations/page/${id}`,
    method: 'get',
    params: query
  })
}

export function delItemObj(id) {
  return request({
    url: '/basic/admin/topic/' + id,
    method: 'delete'
  })
}

export function delRelateTagObj(id) {
  return request({
    url: '/basic/admin/topic-relations/' + id,
    method: 'delete'
  })
}

export function putItemObj(obj) {
  return request({
    url: '/basic/admin/topic',
    method: 'put',
    data: obj
  })
}

export function addNewTag(obj) {
  return request({
    url: '/basic/admin/topic',
    method: 'post',
    data: obj
  })
}

export function approveTag (id) {
  return request({
    url: `/basic/admin/topic/approve/${id}`,
    method: 'put'
  })
}

export function rejectTag (id) {
  return request({
    url: `/basic/admin/topic/reject/${id}`,
    method: 'put'
  })
}

export function hotTag(id, sort) {
    return request({
        url: `/basic/admin/topic/hot/${id}/${sort}`,
        method: 'put',
    })
}

export function coolTag(id) {
    return request({
        url: `/basic/admin/topic/cool/${id}`,
        method: 'put'
    })
}

//批量添加关联标签
export function addRelationTags(tagRelations) {
  return request({
    url: '/basic/admin/topic-relations/add',
    method: 'post',
    data: tagRelations
  })
}